import defineSection from '~/spa/section';
import FAVICONS from 'shared/favicons';
import sectionHead from '~/spa/head';

export default defineSection({
    head: sectionHead({title: 'My Stuff', icon: FAVICONS.stuff, appleIcon: FAVICONS.stuff_apple}),
    routes: [
        {
            path: '/dashboard/',
            component: () => import(/* webpackChunkName: "dashboard" */ './DashboardList.vue'),
            name: 'DashboardList',
        },
    ]
});
